import { Stack, Text } from "@mantine/core";

interface PreferredLocationsDisplayProps {
  preferredLocations: Array<{ id: number; name: string }>;
  selectedLocationId?: number | null;
  selectedLocationName?: string | null;
}

export const PreferredLocationsDisplay = ({
  preferredLocations,
  selectedLocationId,
  selectedLocationName,
}: PreferredLocationsDisplayProps) => {
  return (
    <Stack gap="xs">
      <Text c="black" size="sm" fw={700}>
        선호 장소:
      </Text>
      {preferredLocations.length > 0 ? (
        <Stack gap="xs" pl="md">
          {preferredLocations.map((location, index) => {
            const isMatch =
              (selectedLocationId !== null && selectedLocationId !== undefined && location.id === selectedLocationId) ||
              (selectedLocationName !== null && selectedLocationName !== undefined && location.name === selectedLocationName);
            return (
              <Text
                key={index}
                c="black"
                size="sm"
                style={{
                  backgroundColor: isMatch ? "lightgreen" : undefined,
                  padding: isMatch ? "2px 4px" : undefined,
                  borderRadius: isMatch ? "4px" : undefined,
                }}
              >
                • {location.name}
              </Text>
            );
          })}
        </Stack>
      ) : (
        <Text c="gray" size="sm" pl="md">
          장소 미정
        </Text>
      )}
    </Stack>
  );
};
